import React, { Fragment, PureComponent } from "react";

import {
  BarChart,
  Bar,
  Tooltip,
  ResponsiveContainer,
  XAxis,
  PieChart,
  Pie,
  Cell,
} from "recharts";

import Loader from "./../../Loader/Loader.js";
import { Metric, StandardTooltip, selectFormat } from "./../../Utils/Utils.js";

import Heading from "./../../Elements/Heading";

const color = {
  fans: "#FC6D52",
  post_reach: "#007bff",
  engagement_rate: "#28a745",
  engagements: "#e83e8c",
  link_clicks: "#FBD14A",
  impressions: "#F11F8E",
};

const COLORS = ["#FC6D52", "#f4f4f4"];

class FacebookKeyStats extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      width: 0,
      height: 0,
      tooltipFans: {
        show: false,
        x: 0,
        y: 0,
      },
      tooltipPostReach: {
        show: false,
        x: 0,
        y: 0,
      },
      tooltipEngagementRate: {
        show: false,
        x: 0,
        y: 0,
      },
      tooltipEngagements: {
        show: false,
        x: 0,
        y: 0,
      },
      tooltipLinkClicks: {
        show: false,
        x: 0,
        y: 0,
      },
      tooltipImpressions: {
        show: false,
        x: 0,
        y: 0,
      },
    };

    this.node = React.createRef();
    this.fansPosition = React.createRef();
    this.postReachPosition = React.createRef();
    this.engagementRatePosition = React.createRef();
    this.engagementsPosition = React.createRef();
    this.linkClicksPosition = React.createRef();
    this.impressionsPosition = React.createRef();
  }

  componentDidMount() {
    this.props.childRef(this);
  }

  getExportData = () => ({
    data: [
      {
        Metric: "Total Fans",
        Value: selectFormat(
          "number",
          this.props.data.metrics.fans.value,
          "0,0"
        ),
      },
      {
        Metric: "Post Reach",
        Value: selectFormat(
          "number",
          this.props.data.metrics.post_reach.value,
          "0,0"
        ),
      },
      {
        Metric: "Engagement Rate",
        Value: selectFormat(
          "percentage",
          this.props.data.metrics.engagement_rate.value,
          "%0.0"
        ),
      },
      {
        Metric: "Engagements",
        Value: selectFormat(
          "number",
          this.props.data.metrics.engagements.value,
          "0,0"
        ),
      },
      {
        Metric: "Impressions",
        Value: selectFormat(
          "number",
          this.props.data.metrics.impressions.value,
          "0,0"
        ),
      },
      {
        Metric: "Link Clicks",
        Value: selectFormat(
          "number",
          this.props.data.metrics.link_clicks.value,
          "0,0"
        ),
      },
    ],
    opts: {
      type: "other",
    },
  });

  postReachPieChart = (data) => [
    { value: 100 * data.metrics.post_reach.paid },
    { value: 100 * (1 - data.metrics.post_reach.paid) },
  ];

  render() {
    const { loading } = this.props;

    if (loading) {
      return <Loader minHeight={340} col={"col-12 col-md-6"} />;
    }

    const data = this.props.data;
    // const goal = data.per_brand

    return (
      <div className="row key-stats border-between-metrics">
        <div
          className="col-lg-2 col-sm-6 col-12 key-stats--item"
          ref={this.fansPosition}
        >
          <div className="row row--header">
            <div className="col-12">
              <Heading size={5}>Total Fans</Heading>

              <Metric {...data.metrics.fans} size={"md"} />
            </div>
            {/* {
              goal ? (
                <div className="col-5 mt-1">
                  <Heading size={6} className="mb-1 avg-brand">Compare with: <br/> NBCU Average Per Brand</Heading>
                  <Metric value={goal.fans} size={"sm"} icon="line" />
                </div>
              ) : null
            } */}
          </div>

          <ResponsiveContainer
            height={150}
            width="100%"
            className="mt-5"
            ref={this.divPosition}
          >
            <BarChart
              data={data.metricsByDay.map((d) => ({
                date: d.date,
                value: d.fans,
              }))}
            >
              {!this.state.tooltipFans.show && (
                <Tooltip
                  cursor={{ fill: "#eee", opacity: 0.5 }}
                  content={
                    <StandardTooltip
                      render={({ data }) => {
                        const payload = data(this.props);
                        if (payload !== null) {
                          return (
                            <div className="standard-tooltip">
                              {Object.keys(payload).map((key) => (
                                <Fragment key={key}>
                                  <header className="standard-tooltip__header">
                                    <span className="standard-tooltip__key-header">
                                      New Fans
                                    </span>
                                  </header>
                                  <main className="standard-tooltip__main">
                                    <div className="standard-tooltip__item">
                                      <span className="standard-tooltip__key">
                                        <span
                                          className="standard-tooltip__icon"
                                          style={{ background: color.fans }}
                                        ></span>
                                        <span className="standard-tooltip__value-header">
                                          {selectFormat(
                                            "date",
                                            payload[key].payload.date,
                                            "MM/DD"
                                          )}
                                        </span>
                                      </span>
                                      <span className="standard-tooltip__value">
                                        {selectFormat(
                                          "number",
                                          payload[key].value
                                        )}
                                      </span>
                                    </div>
                                  </main>
                                </Fragment>
                              ))}
                            </div>
                          );
                        }
                      }}
                    />
                  }
                />
              )}
              <defs>
                <linearGradient
                  id={`color-${color.fans}`}
                  x1="0"
                  y1="0"
                  x2="0"
                  y2="1"
                >
                  <stop offset="5%" stopColor={color.fans} stopOpacity={0.55} />
                  <stop offset="95%" stopColor={color.fans} stopOpacity={1} />
                </linearGradient>
              </defs>
              <Bar
                dataKey="value"
                fillOpacity={1}
                fill={`url(#color-${color.fans})`}
                cursor="pointer"
              />
              <XAxis dataKey="date" hide />
              {/* {goal ? <ReferenceLine y={goal.fans} strokeDasharray="3 3" stroke="#FC6D52" ifOverflow="extendDomain" /> : null} */}
            </BarChart>
          </ResponsiveContainer>
        </div>

        <div
          className="col-lg-2 col-sm-6 col-12 key-stats--item"
          ref={this.postReachPosition}
        >
          <div className="row row--header">
            <div className="col-12">
              <Heading size={5}>Post Reach</Heading>

              <Metric {...data.metrics.post_reach} size={"md"} />

              <div className="row pie-metric align-items-center">
                <div className="col-6">
                  <PieChart height={45} width={45}>
                    <Pie
                      dataKey="value"
                      data={this.postReachPieChart(data)}
                      outerRadius="100%"
                      innerRadius="75%"
                      startAngle={450}
                      endAngle={90}
                    >
                      {this.postReachPieChart(data).map((entry, index) => (
                        <Cell key={`cell-${entry}`} fill={COLORS[index]} />
                      ))}
                    </Pie>
                    <text
                      x="50%"
                      y="50%"
                      textAnchor="middle"
                      dominantBaseline="middle"
                      className="piechart-metric__xsmall"
                    >
                      {selectFormat(
                        "percentage",
                        this.postReachPieChart(data)[0].value / 100
                      )}
                    </text>
                  </PieChart>
                </div>
                <div className="col-6">
                  <h6 className="widget__metric-label ml-2 mt-2">Paid</h6>
                </div>
              </div>
            </div>
            {/* {
              goal ? (
                <div className="col-5 mt-1">
                  <Heading size={6} className="mb-1 avg-brand">Compare with: <br/> NBCU Average Per Brand</Heading>
                  <Metric value={goal.post_reach} size={"sm"} icon="line" />
                </div>
              ) : null
            } */}
          </div>

          <ResponsiveContainer height={150} width="100%" className="mt-5">
            <BarChart
              data={data.metricsByDay.map((d) => ({
                date: d.date,
                value: d.post_reach,
              }))}
            >
              {!this.state.tooltipPostReach.show && (
                <Tooltip
                  cursor={{ fill: "#eee", opacity: 0.5 }}
                  content={
                    <StandardTooltip
                      render={({ data }) => {
                        const payload = data(this.props);
                        if (payload !== null) {
                          return (
                            <div className="standard-tooltip">
                              {Object.keys(payload).map((key) => (
                                <Fragment key={key}>
                                  <header className="standard-tooltip__header">
                                    <span className="standard-tooltip__key-header">
                                      Post Reach
                                    </span>
                                  </header>
                                  <main className="standard-tooltip__main">
                                    <div className="standard-tooltip__item">
                                      <span className="standard-tooltip__key">
                                        <span
                                          className="standard-tooltip__icon"
                                          style={{
                                            background: color.post_reach,
                                          }}
                                        ></span>
                                        <span className="standard-tooltip__value-header">
                                          {selectFormat(
                                            "date",
                                            payload[key].payload.date,
                                            "MM/DD"
                                          )}
                                        </span>
                                      </span>
                                      <span className="standard-tooltip__value">
                                        {selectFormat(
                                          "number",
                                          payload[key].value
                                        )}
                                      </span>
                                    </div>
                                  </main>
                                </Fragment>
                              ))}
                            </div>
                          );
                        }
                      }}
                    />
                  }
                />
              )}
              <defs>
                <linearGradient
                  id={`color-${color.post_reach}`}
                  x1="0"
                  y1="0"
                  x2="0"
                  y2="1"
                >
                  <stop
                    offset="5%"
                    stopColor={color.post_reach}
                    stopOpacity={0.55}
                  />
                  <stop
                    offset="95%"
                    stopColor={color.post_reach}
                    stopOpacity={1}
                  />
                </linearGradient>
              </defs>
              <Bar
                dataKey="value"
                fillOpacity={1}
                fill={`url(#color-${color.post_reach})`}
                cursor="pointer"
              />
              <XAxis dataKey="date" hide />
              {/* {goal ? <ReferenceLine y={goal.post_reach} strokeDasharray="3 3" stroke="#FC6D52" ifOverflow="extendDomain" /> : null} */}
            </BarChart>
          </ResponsiveContainer>
        </div>

        <div
          className="col-lg-2 col-sm-6 col-12 key-stats--item"
          ref={this.engagementRatePosition}
        >
          <div className="row row--header">
            <div className="col-12">
              <Heading size={5}>Engagement Rate</Heading>

              <Metric
                {...data.metrics.engagement_rate}
                size={"md"}
                type={"percentage"}
              />
            </div>
            {/* {
              goal ? (
                <div className="col-5 mt-1">
                  <Heading size={6} className="mb-1 avg-brand">Compare with: <br/> NBCU Average Per Brand</Heading>
                  <Metric value={goal.engagement_rate} size={"sm"} icon="line" />
                </div>
              ) : null
            } */}
          </div>

          <ResponsiveContainer height={150} width="100%" className="mt-5">
            <BarChart
              data={data.metricsByDay.map((d) => ({
                date: d.date,
                value: d.engagement_rate,
              }))}
            >
              {!this.state.tooltipEngagementRate.show && (
                <Tooltip
                  cursor={{ fill: "#eee", opacity: 0.5 }}
                  content={
                    <StandardTooltip
                      render={({ data }) => {
                        const payload = data(this.props);
                        if (payload !== null) {
                          return (
                            <div className="standard-tooltip">
                              {Object.keys(payload).map((key) => (
                                <Fragment key={key}>
                                  <header className="standard-tooltip__header">
                                    <span className="standard-tooltip__key-header">
                                      Engaged Users
                                    </span>
                                  </header>
                                  <main className="standard-tooltip__main">
                                    <div className="standard-tooltip__item">
                                      <span className="standard-tooltip__key">
                                        <span
                                          className="standard-tooltip__icon"
                                          style={{
                                            background: color.engagement_rate,
                                          }}
                                        ></span>
                                        <span className="standard-tooltip__value-header">
                                          {selectFormat(
                                            "date",
                                            payload[key].payload.date,
                                            "MM/DD"
                                          )}
                                        </span>
                                      </span>
                                      <span className="standard-tooltip__value">
                                        {selectFormat(
                                          "percentage",
                                          payload[key].value,
                                          "%0.0"
                                        )}
                                      </span>
                                    </div>
                                  </main>
                                </Fragment>
                              ))}
                            </div>
                          );
                        }
                      }}
                    />
                  }
                />
              )}
              <defs>
                <linearGradient
                  id={`color-${color.engagement_rate}`}
                  x1="0"
                  y1="0"
                  x2="0"
                  y2="1"
                >
                  <stop
                    offset="5%"
                    stopColor={color.engagement_rate}
                    stopOpacity={0.55}
                  />
                  <stop
                    offset="95%"
                    stopColor={color.engagement_rate}
                    stopOpacity={1}
                  />
                </linearGradient>
              </defs>
              <Bar
                dataKey="value"
                fillOpacity={1}
                fill={`url(#color-${color.engagement_rate})`}
                cursor="pointer"
              />
              <XAxis dataKey="date" hide />
              {/* {goal ? <ReferenceLine y={goal.engagement_rate} strokeDasharray="3 3" stroke="#FC6D52" ifOverflow="extendDomain" /> : null} */}
            </BarChart>
          </ResponsiveContainer>
        </div>

        <div
          className="col-lg-2 col-sm-6 col-12 key-stats--item"
          ref={this.engagementsPosition}
        >
          <div className="row row--header">
            <div className="col-12">
              <Heading size={5}>Engagements</Heading>

              <Metric {...data.metrics.engagements} size={"md"} />
            </div>
            {/* {
              goal ? (
                <div className="col-5 mt-1">
                  <Heading size={6} className="mb-1 avg-brand">Compare with: <br/> NBCU Average Per Brand</Heading>
                  <Metric value={goal.engagements} size={"sm"} icon="line" />
                </div>
              ) : null
            } */}
          </div>

          <ResponsiveContainer height={150} width="100%" className="mt-5">
            <BarChart
              data={data.metricsByDay.map((d) => ({
                date: d.date,
                value: d.engagements,
              }))}
            >
              {!this.state.tooltipEngagements.show && (
                <Tooltip
                  cursor={{ fill: "#eee", opacity: 0.5 }}
                  content={
                    <StandardTooltip
                      render={({ data }) => {
                        const payload = data(this.props);
                        if (payload !== null) {
                          return (
                            <div className="standard-tooltip">
                              {Object.keys(payload).map((key) => (
                                <Fragment key={key}>
                                  <header className="standard-tooltip__header">
                                    <span className="standard-tooltip__key-header">
                                      Engagements
                                    </span>
                                  </header>
                                  <main className="standard-tooltip__main">
                                    <div className="standard-tooltip__item">
                                      <span className="standard-tooltip__key">
                                        <span
                                          className="standard-tooltip__icon"
                                          style={{
                                            background: color.engagements,
                                          }}
                                        ></span>
                                        <span className="standard-tooltip__value-header">
                                          {selectFormat(
                                            "date",
                                            payload[key].payload.date,
                                            "MM/DD"
                                          )}
                                        </span>
                                      </span>
                                      <span className="standard-tooltip__value">
                                        {selectFormat(
                                          "number",
                                          payload[key].value
                                        )}
                                      </span>
                                    </div>
                                  </main>
                                </Fragment>
                              ))}
                            </div>
                          );
                        }
                      }}
                    />
                  }
                />
              )}
              <defs>
                <linearGradient
                  id={`color-${color.engagements}`}
                  x1="0"
                  y1="0"
                  x2="0"
                  y2="1"
                >
                  <stop
                    offset="5%"
                    stopColor={color.engagements}
                    stopOpacity={0.55}
                  />
                  <stop
                    offset="95%"
                    stopColor={color.engagements}
                    stopOpacity={1}
                  />
                </linearGradient>
              </defs>
              <Bar
                dataKey="value"
                fillOpacity={1}
                fill={`url(#color-${color.engagements})`}
                cursor="pointer"
              />
              <XAxis dataKey="date" hide />
              {/* {goal ? <ReferenceLine y={goal.engagements} strokeDasharray="3 3" stroke="#FC6D52" ifOverflow="extendDomain" /> : null} */}
            </BarChart>
          </ResponsiveContainer>
        </div>

        <div
          className="col-lg-2 col-sm-6 col-12 key-stats--item"
          ref={this.impressionsPosition}
        >
          <div className="row row--header">
            <div className="col-12">
              <Heading size={5}>Impressions</Heading>

              <Metric {...data.metrics.impressions} size={"md"} />
            </div>
            {/* {
              goal ? (
                <div className="col-5 mt-1">
                  <Heading size={6} className="mb-1 avg-brand">Compare with: <br/> NBCU Average Per Brand</Heading>
                  <Metric value={goal.impressions} size={"sm"} icon="line" />
                </div>
              ) : null
            } */}
          </div>

          <ResponsiveContainer height={150} width="100%" className="mt-5">
            <BarChart
              data={data.metricsByDay.map((d) => ({
                date: d.date,
                value: d.impressions,
              }))}
            >
              {!this.state.tooltipImpressions.show && (
                <Tooltip
                  cursor={{ fill: "#eee", opacity: 0.5 }}
                  content={
                    <StandardTooltip
                      render={({ data }) => {
                        const payload = data(this.props);
                        if (payload !== null) {
                          return (
                            <div className="standard-tooltip">
                              {Object.keys(payload).map((key) => (
                                <Fragment key={key}>
                                  <header className="standard-tooltip__header">
                                    <span className="standard-tooltip__key-header">
                                      Impressions
                                    </span>
                                  </header>
                                  <main className="standard-tooltip__main">
                                    <div className="standard-tooltip__item">
                                      <span className="standard-tooltip__key">
                                        <span
                                          className="standard-tooltip__icon"
                                          style={{
                                            background: color.impressions,
                                          }}
                                        ></span>
                                        <span className="standard-tooltip__value-header">
                                          {selectFormat(
                                            "date",
                                            payload[key].payload.date,
                                            "MM/DD"
                                          )}
                                        </span>
                                      </span>
                                      <span className="standard-tooltip__value">
                                        {selectFormat(
                                          "number",
                                          payload[key].value
                                        )}
                                      </span>
                                    </div>
                                  </main>
                                </Fragment>
                              ))}
                            </div>
                          );
                        }
                      }}
                    />
                  }
                />
              )}
              <defs>
                <linearGradient
                  id={`color-${color.impressions}`}
                  x1="0"
                  y1="0"
                  x2="0"
                  y2="1"
                >
                  <stop
                    offset="5%"
                    stopColor={color.impressions}
                    stopOpacity={0.55}
                  />
                  <stop
                    offset="95%"
                    stopColor={color.impressions}
                    stopOpacity={1}
                  />
                </linearGradient>
              </defs>
              <Bar
                dataKey="value"
                fillOpacity={1}
                fill={`url(#color-${color.impressions})`}
                cursor="pointer"
              />
              <XAxis dataKey="date" hide />
              {/* {goal ? <ReferenceLine y={goal.impressions} strokeDasharray="3 3" stroke="#FC6D52" ifOverflow="extendDomain" /> : null} */}
            </BarChart>
          </ResponsiveContainer>
        </div>

        <div
          className="col-lg-2 col-sm-6 col-12 key-stats--item"
          ref={this.linkClicksPosition}
        >
          <div className="row row--header">
            <div className="col-12">
              <Heading size={5}>Link Clicks</Heading>

              <Metric {...data.metrics.link_clicks} size={"md"} />
            </div>
            {/* {
              goal ? (
                <div className="col-5 mt-1">
                  <Heading size={6} className="mb-1 avg-brand">Compare with: <br/> NBCU Average Per Brand</Heading>
                  <Metric value={goal.link_clicks} size={"sm"} icon="line" />
                </div>
              ) : null
            } */}
          </div>
          <ResponsiveContainer height={150} width="100%" className="mt-5">
            <BarChart
              data={data.metricsByDay.map((d) => ({
                date: d.date,
                value: d.link_clicks,
              }))}
            >
              {!this.state.tooltipLinkClicks.show && (
                <Tooltip
                  cursor={{ fill: "#eee", opacity: 0.5 }}
                  content={
                    <StandardTooltip
                      render={({ data }) => {
                        const payload = data(this.props);
                        if (payload !== null) {
                          return (
                            <div className="standard-tooltip">
                              {Object.keys(payload).map((key) => (
                                <Fragment key={key}>
                                  <header className="standard-tooltip__header">
                                    <span className="standard-tooltip__key-header">
                                      Link Clicks
                                    </span>
                                  </header>
                                  <main className="standard-tooltip__main">
                                    <div className="standard-tooltip__item">
                                      <span className="standard-tooltip__key">
                                        <span
                                          className="standard-tooltip__icon"
                                          style={{
                                            background: color.link_clicks,
                                          }}
                                        ></span>
                                        <span className="standard-tooltip__value-header">
                                          {selectFormat(
                                            "date",
                                            payload[key].payload.date,
                                            "MM/DD"
                                          )}
                                        </span>
                                      </span>
                                      <span className="standard-tooltip__value">
                                        {selectFormat(
                                          "number",
                                          payload[key].value
                                        )}
                                      </span>
                                    </div>
                                  </main>
                                </Fragment>
                              ))}
                            </div>
                          );
                        }
                      }}
                    />
                  }
                />
              )}
              <defs>
                <linearGradient
                  id={`color-${color.link_clicks}`}
                  x1="0"
                  y1="0"
                  x2="0"
                  y2="1"
                >
                  <stop
                    offset="5%"
                    stopColor={color.link_clicks}
                    stopOpacity={0.55}
                  />
                  <stop
                    offset="95%"
                    stopColor={color.link_clicks}
                    stopOpacity={1}
                  />
                </linearGradient>
              </defs>
              <Bar
                dataKey="value"
                fillOpacity={1}
                fill={`url(#color-${color.link_clicks})`}
                cursor="pointer"
              />
              <XAxis dataKey="date" hide />
              {/* {goal ? <ReferenceLine y={goal.link_clicks} strokeDasharray="3 3" stroke="#FC6D52" ifOverflow="extendDomain" /> : null} */}
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>
    );
  }
}

export default FacebookKeyStats;
